import { indexItems } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">主题索引</h2>
          <p className="text-sm text-foreground-500">按分类快速发现你感兴趣的漫画专题</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-start gap-4 bg-background-100 rounded-lg p-4 border border-background-200/80 hover:border-primary-200 transition-colors cursor-pointer no-underline"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <span className={`flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center ${item.iconBg}`}>
                <i className={`${item.icon} text-lg ${item.iconColor}`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-0.5">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-1.5">{item.desc}</p>
                <span className="text-[10px] font-medium text-primary-600 bg-primary-100/60 px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
          {/* 最后一格补满 grid */}
          <div className="lg:hidden"></div>
        </div>
      </div>
    </section>
  );
}